import { useGLTF } from '@react-three/drei';
import { useRef, useMemo } from 'react';
import { Mesh, BoxGeometry, MeshStandardMaterial } from 'three';

export function Buildings() {
  const buildingsRef = useRef < Mesh > (null);
  const { scene } = useGLTF("/models/building.glb");

  const buildingPositions = useMemo(() => [
    [-30, 20], [-10, 20], [10, 20], [30, 20],
    [-30, -20], [-10, -20], [10, -20], [30, -20]
  ], []);

  return (
    <group>
      {buildingPositions.map(([x, z], i) => (
        <primitive
          key={i}
          object={scene.clone()}
          position={[x, 0, z]}
          scale={[0.01, 0.01, 0.01]}
          rotation={[0, z > 0 ? -Math.PI / 2 : Math.PI / 2, 0]} // Yukarıdakiler sağa, aşağıdakiler sola
          castShadow
        />
      ))}
    </group>
  );
}